import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IRolePermissionsData, IRolePermissionsResponse } from '../types';
import { ROLE_PERMISSIONS_API_URL, ROLE_PERMISSIONS_QUERY, ROLES_PERMISSIONS } from '../constants';

export default function useRolePermissionsQuery(
  roleId: Ref<number | undefined>,
): IContextQueryResult<IRolePermissionsResponse, Error, IRolePermissionsData> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IRolePermissionsResponse, Error, IRolePermissionsData>({
    queryKey: [ROLE_PERMISSIONS_QUERY, roleId],
    queryFn: ({ signal }) => fetchGet<IRolePermissionsResponse>(
      ROLE_PERMISSIONS_API_URL,
      {
        signal,
        permission: ROLES_PERMISSIONS.ROLES_CREATE,
        urlParams: {
          roleId: roleId.value,
        },
      },
    ),
    enabled: computed(() => !!roleId.value),
    select: (data) => data.permissions_tree,
    placeholderData: keepPreviousData,
  });
}
